module.exports = __webpack_public_path__ + "img/airbase-stage_5.1.f3b36363.jpg";